import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated for React 18
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  process.env.REACT_APP_GOOGLE_CLIENTID ||
  '634179776123-n1junulqen2ehfpfk06ra5aef586736c.apps.googleusercontent.com';

if (!googleClientId) {
  console.error('Google OAuth client ID is missing. Set REACT_APP_GOOGLE_CLIENT_ID before building.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();